'use client';

import { type ReactNode, createContext, useRef, type JSX } from 'react';

import type { VehicleAssignmentState } from '../store/vehicleAssignmentStore';
import { createVehicleAssignmentStore } from '../store/vehicleAssignmentStore';

export type VehicleAssignmentStoreApi = ReturnType<typeof createVehicleAssignmentStore>;

export type VehicleAssignmentStoreProviderProps = {
    children: ReactNode;
    vehicleAssignmentState?: VehicleAssignmentState;
};

// TODO: Refactor this later to use the correct naming convention
// eslint-disable-next-line @typescript-eslint/naming-convention
export const VehicleAssignmentStoreContext = createContext<VehicleAssignmentStoreApi | undefined>(undefined);

export function VehicleAssignmentStoreProvider({ children, vehicleAssignmentState }: VehicleAssignmentStoreProviderProps): JSX.Element {
    const storeRef = useRef<VehicleAssignmentStoreApi>(undefined);

    if (!storeRef.current) {
        storeRef.current = createVehicleAssignmentStore(vehicleAssignmentState);
    }

    return <VehicleAssignmentStoreContext.Provider value={storeRef.current}>{children}</VehicleAssignmentStoreContext.Provider>;
}
